import { render } from "./EnvironmentAir.vue?vue&type=template&id=24aaf825&ts=true"
import script from "./EnvironmentAir.vue?vue&type=script&lang=ts"
export * from "./EnvironmentAir.vue?vue&type=script&lang=ts"

import "./EnvironmentAir.vue?vue&type=style&index=0&id=24aaf825&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__